module.exports = __webpack_public_path__ + "static/media/traffic.b16b9d45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/traffic.svg
// module id = 174
// module chunks = 0